<script>
  import { createEventDispatcher } from 'svelte';

  import firebase from "firebase/app";

  const dispatch = createEventDispatcher();

  export let answerId;
  export let issueId;
  export let answer;

  async function vote() {
    const db = firebase.database();

    await db.ref(`/answers/${issueId}/${answerId}`).update({
      point: firebase.database.ServerValue.increment(1),
    });
    const newRef = await db.ref(`/answers/${issueId}/${answerId}/votes`).push({
      createdAt: (new Date()).toISOString(),
    });
    dispatch("vote", {});
  }

  function formatDate(date) {
    const d = new Date(date);
    if (d.toString() === "Invalid Date") {
      return "";
    }
    const formatter = new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: false,
    });
    return formatter.format(d);
  }
</script>
<div class="answer">
  <p class="body">{ answer.body }</p>
  <div class="row">
    <div class="col"><span class="answerer">{ answer.answerer }</span></div>
    <div class="col"><span class="point">{ answer.point }</span> pt</div>
  </div>
  <div class="row">
    <div class="col date">{ formatDate(answer.createdAt) }</div>
    <div class="col"><button type="button" on:click={vote}>投票</button></div>
  </div>
</div>
<style>
  .answer {
    background-color: #FFF5E6;
    padding: 5px;
    margin-bottom: 10px;
    border: 2px solid #FFF0E0;
  }
  .body {
    font-weight: bold;
    margin: 2px;
    min-height: 40px;
  }
  .row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 2px;
    font-size: 0.9em;
  }
  .date {
    color: #999;
  }
</style>
